import { SupportAgent } from "@mui/icons-material";
import { User } from "lucide-react";

const ChatMessage = ({ message, isUser, timestamp }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: isUser ? "row-reverse" : "row",
        gap: "12px",
        marginBottom: "16px",
      }}
    >
      <div
        style={{
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "32px",
          height: "32px",
          borderRadius: "50%",
          backgroundColor: isUser ? "#E3F2FD" : "#F5F5F5",
        }}
      >
        {isUser ? (
          <User
            style={{
              fontSize: "24px",
              color: "#1E88E5",
            }}
          />
        ) : (
          <SupportAgent style={{ fontSize: "24px", color: "#9E9E9E" }} />
        )}
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "400px",
          alignItems: isUser ? "flex-end" : "flex-start",
        }}
      >
        <div
          style={{
            padding: "8px 16px",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
            backgroundColor: isUser ? "#E3F2FD" : "#F5F5F5",
            color: isUser ? "#1E88E5" : "#333",
            borderRadius: isUser ? "16px 16px 0 16px" : "16px 16px 16px 0",
            border: isUser ? "none" : "1px solid #E0E0E0",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              lineHeight: "1.5",
            }}
          >
            {message.type === "text" ? (
              <span>{message.content}</span>
            ) : message.type === "image" ? (
              <div>
                <img
                  src={message.content}
                  alt={message.caption}
                  style={{ maxWidth: "100%", margin: "5px 0" }}
                />
                {message.caption && <p>{message.caption}</p>}
              </div>
            ) : null}
          </p>
        </div>
        <span
          style={{
            fontSize: "12px",
            color: "#9E9E9E",
            marginTop: "4px",
            padding: "0 8px",
          }}
        >
          {timestamp.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </span>
      </div>
    </div>
  );
};

export default ChatMessage;
